type IconProps = {
  size?: number;
  className?: string;
};

const SideDishIcon = ({ size = 35, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Posuda */}
      <path d="M4 13h16a8 8 0 0 1-16 0z" />

      {/* Krompir */}
      <ellipse cx="9" cy="10" rx="2.2" ry="1.6" />

      {/* Brokoli */}
      <circle cx="14.2" cy="8.3" r="1.3" />
      <circle cx="15.8" cy="9.1" r="1.2" />
      <circle cx="13" cy="9.2" r="1.2" />
      <path d="M14.2 10v1.5" />
    </svg>
  );
};

export default SideDishIcon;